<ng-container *ngIf="product$ | async as product">
  <ul>
    @if (product.keySpecs?.length) {
      <li *ngFor="let spec of product.keySpecs">{{ spec }}</li>
    } @else {
      <li>{{ 'keyFeatures.noContent' | cxTranslate }}</li>
    }
  </ul>
</ng-container>
